/**
 * Static Career Fair content (placeholder until API-driven).
 * Year-specific overrides can be added under `byYear`.
 */

export const defaultCareerFair = {
  tagline: "Connect. Explore. Succeed.",
  hashtagPrefix: "IATCareerFair",
  dateLabel: "Monday, February 17, 2025",
  timeLabel: "9:30 a.m.–5:00 p.m.",
  locationLabel: "IAT Sports Complex",
  intro:
    "The annual IAT Career Fair is an opportunity for students and alumni eager to take their first, or next, step in their careers. Join us to explore, connect and network with leading organizations and take a step towards achieving your dream career.",
  registerCta: "Register now and secure your spot!",
  registerUrl: "https://forms.gle/example-career-fair-register",
  contactEmail: "careerservices@iat.ac.ae",
  contactPhone: "02 123 4567",
  socialLinks: [
    {
      platform: "instagram",
      label: "@iat_alumni",
      url: "https://www.instagram.com/iat_alumni",
    },
    {
      platform: "linkedin",
      label: "IAT Alumni",
      url: "https://www.linkedin.com/company/institute-of-applied-technology",
    },
    {
      platform: "facebook",
      label: "IAT Alumni",
      url: "https://www.facebook.com/iat.alumni",
    },
    {
      platform: "youtube",
      label: "IAT Alumni",
      url: "https://www.youtube.com/@iat_alumni",
    },
    {
      platform: "x",
      label: "@iat_alumni",
      url: "https://x.com/iat_alumni",
    },
  ],
  navCards: [
    { id: "sponsors", label: "Sponsors", imageKey: "sponsors" },
    { id: "companies", label: "Participating Companies", imageKey: "companies" },
    { id: "visit-us", label: "Visit Us", imageKey: "visit" },
    { id: "exhibit", label: "Exhibit With Us", imageKey: "exhibit" },
    { id: "getting-ready", label: "Getting Ready for Career Fair", imageKey: "ready" },
    { id: "jobs", label: "Jobs", imageKey: "jobs" },
    { id: "campus", label: "Coming to Campus", imageKey: "campus" },
    { id: "faqs", label: "FAQs", imageKey: "faqs" },
    { id: "contact", label: "Contact Us", imageKey: "contact" },
  ],
  sponsors: {
    platinum: [
      { name: "Emirates NBD", initials: "ENBD" },
      { name: "Samsung", initials: "SAM" },
    ],
    gold: [{ name: "HSBC", initials: "HSBC" }],
    silver: [
      { name: "Arada", initials: "ARD" },
      { name: "Dubai Airports", initials: "DXB" },
      { name: "P&G", initials: "P&G" },
    ],
    bronze: [
      { name: "Deloitte", initials: "DEL" },
      { name: "Henkel", initials: "HEN" },
      { name: "L'Oréal", initials: "LOR" },
      { name: "Nestlé", initials: "NES" },
      { name: "TotalEnergies", initials: "TE" },
      { name: "PwC", initials: "PwC" },
      { name: "EY", initials: "EY" },
      { name: "Visa", initials: "VISA" },
    ],
    institutional: [
      { name: "Bee'ah", initials: "BEE" },
      { name: "Crescent Petroleum", initials: "CP" },
    ],
  },
  companies: [
    { name: "Accenture", url: "https://www.accenture.com/ae-en" },
    { name: "AECOM", url: "https://www.aecom.com" },
    { name: "Apparel Group" },
    { name: "Arada", url: "https://www.arada.com" },
    { name: "AtkinsRéalis" },
    { name: "Bee'ah Group", url: "https://www.beeahgroup.com" },
    { name: "Citi Bank" },
    { name: "Crescent Petroleum" },
    { name: "Cummins", url: "https://www.cummins.com" },
    { name: "Deloitte", url: "https://www.deloitte.com" },
    { name: "DP World", url: "https://www.dpworld.com" },
    { name: "Dow Chemical" },
    { name: "Dubai Airports" },
    { name: "Dubai Police" },
    { name: "EGA" },
    { name: "Emaar", url: "https://www.emaar.com" },
    { name: "Emirates NBD", url: "https://www.emiratesnbd.com" },
    { name: "EY", url: "https://www.ey.com" },
    { name: "Henkel" },
    { name: "HSBC", url: "https://www.hsbc.ae" },
    { name: "L'Oréal", url: "https://www.loreal.com" },
    { name: "Mubadala" },
    { name: "Nestlé" },
    { name: "P&G", url: "https://www.pg.com" },
    { name: "Parsons" },
    { name: "PwC", url: "https://www.pwc.com" },
    { name: "Samsung", url: "https://www.samsung.com" },
    { name: "Schneider Electric" },
    { name: "Siemens", url: "https://www.siemens.com" },
    { name: "Standard Chartered Bank" },
    { name: "TotalEnergies" },
    { name: "Visa", url: "https://www.visa.com" },
    { name: "WSP" },
    { name: "Zebra" },
  ],
  visitUs: {
    title: "Unlock Your Career Potential at the IAT Career Fair",
    exclusiveNote: "This event is open exclusively to IAT students and alumni.",
    body:
      "Take the next step in your professional journey by attending the IAT Career Fair. Connect with leading employers, discover exciting job and internship opportunities, and gain invaluable insights through meaningful interactions with industry professionals.",
    highlights: [
      {
        title: "Connect with Top Employers",
        text:
          "Meet leading companies across various industries, learn about their opportunities, and explore potential career paths.",
      },
      {
        title: "Access Exclusive Opportunities",
        text:
          "Discover internships and job openings tailored to IAT students and graduates, giving you a competitive edge in the job market.",
      },
      {
        title: "Expand Your Professional Network",
        text:
          "Establish valuable connections with employers and industry leaders, opening doors to exciting career opportunities.",
      },
    ],
  },
  exhibit: {
    intro:
      "Participating in the IAT Career Fair offers a unique opportunity to connect with top-tier talent and expand your network. By joining, you’re not just recruiting talent—you’re investing in the future of your workforce while showcasing your organization as a leader in fostering professional growth.",
    benefits: [
      {
        title: "Build Awareness",
        text:
          "Showcase your organization’s brand and values directly to a diverse and talented pool of students and alumni.",
      },
      {
        title: "Attract Top Talent",
        text:
          "Connect with exceptional students and alumni from engineering, applied sciences, business, and technology programs across IAT institutes.",
      },
      {
        title: "Support Emiratization Goals",
        text:
          "Gain access to a talented pool of UAE Nationals and help fulfill your Emiratization targets effectively.",
      },
      {
        title: "Achieve Recruitment Efficiency",
        text:
          "Engage directly with pre-screened candidates through one-on-one interactions and targeted networking opportunities.",
      },
      {
        title: "Strengthen Employer Reputation",
        text:
          "Position your company as an employer of choice by aligning with IAT’s reputation for excellence in applied education.",
      },
    ],
    cta: "Reserve your space",
    reserveUrl: "https://forms.gle/example-career-fair-exhibit",
  },
  workshops: {
    intro:
      "Prepare to excel in your career journey by attending our transformative workshops before the Career Fair!",
    items: [
      {
        title: "CV Writing for Career Success",
        text:
          "Create a standout CV that highlights your skills, experiences and accomplishments. Learn strategies to tailor your CV for specific roles and industries.",
      },
      {
        title: "Master the Interview Skills",
        text:
          "Gain practical insights into mastering interviews—from answering challenging questions to showcasing your unique strengths with confidence.",
      },
      {
        title: "Personal Branding",
        text:
          "Build a powerful professional identity, communicate your value, and create a personal brand that resonates with your career goals.",
      },
    ],
    scheduleIntro:
      "Whether you're just starting your professional journey or looking to advance your career, these workshops give you the tools and confidence to succeed.",
    schedule: [
      { title: "CV Writing for Career Success", date: "January 28, 2025" },
      { title: "Master the Interview Skills", date: "January 29, 2025" },
      { title: "CV Writing for Career Success", date: "February 4, 2025" },
      { title: "Personal Branding", date: "February 5, 2025" },
      { title: "CV Writing for Career Success", date: "February 11, 2025" },
      { title: "Personal Branding", date: "February 12, 2025" },
    ],
    cta: "Register to attend a workshop",
    registerUrl: "https://forms.gle/example-career-fair-workshop",
  },
  campus: {
    text:
      "The on-campus Career Fair will be held at the Main Building / Sports Complex. Visiting alumni and employers may use the visitor parking area as indicated on the campus map.",
    directions: {
      type: "url",
      value: "https://www.google.com/maps/search/?api=1&query=Institute+of+Applied+Technology+UAE",
    },
    campusMap: {
      imageKey: "campusMap",
    },
  },
  jobs: {
    text:
      "Explore internship and full-time opportunities shared by participating employers. Check back closer to the event for the live jobs board.",
    placeholders: [
      { title: "Graduate Engineer", company: "Siemens", type: "Full-time", url: "https://www.siemens.com/global/en/company/jobs.html" },
      { title: "Business Analyst Intern", company: "Deloitte", type: "Internship", url: "https://www.deloitte.com/careers" },
      { title: "Marketing Associate", company: "L'Oréal", type: "Full-time" },
      { title: "IT Support Specialist", company: "Emirates NBD", type: "Full-time", url: "https://www.emiratesnbd.com/en/careers" },
    ],
  },
  faqs: [
    {
      category: "General Information",
      items: [
        {
          q: "Who can attend the IAT Career Fair?",
          a: "The Career Fair is open to IAT students, alumni and invited employers.",
        },
        {
          q: "Can a friend from another university join me?",
          a: "Unfortunately, non-IAT students or alumni are not permitted to attend. This is an exclusive event for IAT students, alumni and invited employers.",
        },
        {
          q: "Where and when is the Career Fair?",
          a: "The event takes place on the date and venue listed at the top of this page.",
        },
        {
          q: "What time does the event start, and how long will it last?",
          a: "The Career Fair typically runs from morning through late afternoon. Exact times are shown in the event details above.",
        },
      ],
    },
    {
      category: "For Students",
      items: [
        {
          q: "Do I need to register to attend?",
          a: "Yes, you are encouraged to register to receive updates and access exclusive resources.",
        },
        {
          q: "How can I prepare for the Career Fair?",
          a: "Bring multiple copies of your updated CV/resume and research participating companies in advance.",
        },
        {
          q: "How should I dress?",
          a: "Professional or business attire is recommended to make a positive impression.",
        },
        {
          q: "Can I apply for jobs or internships during the event?",
          a: "Yes, many employers accept applications during the event, and some may schedule on-the-spot interviews.",
        },
      ],
    },
    {
      category: "For Employers",
      items: [
        {
          q: "How can my company participate?",
          a: "Register via the exhibit link. Participation is subject to the event’s fee structure, with proceeds supporting student scholarships where applicable.",
        },
        {
          q: "What is included in the booth package?",
          a: "Each booth typically includes a table, chairs, power outlet, company signage, lighting and Wi-Fi. Additional requests can be arranged with prior notice.",
        },
        {
          q: "Can we brand our booth?",
          a: "Yes. Booth branding is encouraged. Please ensure materials align with booth dimensions and event guidelines.",
        },
        {
          q: "Are there sponsorship opportunities?",
          a: "Yes. Sponsorship packages offer enhanced visibility and benefits. Contact the Career Services team for details.",
        },
      ],
    },
    {
      category: "For Alumni",
      items: [
        {
          q: "Can alumni attend the Career Fair?",
          a: "Yes. Alumni are welcome to attend, explore opportunities, network with employers and reconnect with the IAT community.",
        },
        {
          q: "Are there specific resources available for alumni?",
          a: "Yes. Career Services offers guidance including CV reviews and career consultations. Book via the contact email below.",
        },
      ],
    },
    {
      category: "Logistics and Support",
      items: [
        {
          q: "Is there parking available?",
          a: "Yes, parking will be available next to the venue.",
        },
        {
          q: "Will there be assistance for setting up booths?",
          a: "We can assist with minor arrangements and provide support on the day of the event.",
        },
        {
          q: "Who can I contact for additional questions?",
          a: "Reach out to Career Services using the contact details at the bottom of this page.",
        },
      ],
    },
  ],
};

/** Optional per-year overrides (merge shallowly over default). */
export const byYear = {
  2026: {
    dateLabel: "Monday, February 16, 2026",
    timeLabel: "9:30 a.m.–5:00 p.m.",
    locationLabel: "IAT Sports Complex",
  },
};

export function getCareerFairData(year) {
  const y = String(year || new Date().getFullYear());
  const override = byYear[y] || {};
  return Object.assign({}, defaultCareerFair, override, { year: y });
}
